
import { Column } from "primereact/column";
import React, {
  forwardRef,
  useImperativeHandle,
  useState,
} from "react";
import MeaDataTable from "../../../../components/MeaDataTable";
import systemAccountsAPI from "../../../../services/system_accounts";

const SystemAccountsListComponent = forwardRef((props, ref) => {
  const { showFilterButton } = props;
  const [page, setPage] = useState();
  const [pageSize, setPageSize] = useState();
  const [email, setEmail] = useState();

  const schoolId = "";
  const trainingId = "";
  const accessToken = "";
  //
  //const createModalRef = useRef();
  //const updateModalRef = useRef();
  //
  //
  const queryList = systemAccountsAPI.useGetList(
    schoolId,
    trainingId,
    accessToken,
    page,
    pageSize,
    email,
  );
  //
  useImperativeHandle(ref, () => ({
    refresh: () => {
      queryList?.refetch();
    },
  }));
  //
  return (
    <>
      <MeaDataTable
        query={queryList}
        serviceAPI={systemAccountsAPI}
        names={{
          pagination: "account",
          singular: "Compte utilisateur",
          plural: "Comptes utilisateurs",
        }}
        showFilterButton={showFilterButton}
        setPage={setPage}
        setPageSize={setPageSize}
        schoolId={schoolId}
        trainingId={trainingId}
      >
        <Column
          selectionMode="multiple"
          headerStyle={{ width: "3rem" }}
        ></Column>
        <Column field="lastname" header="Nom"></Column>
        <Column field="firstname" header="Prénom"></Column>
        <Column field="email" header="E-mail"></Column>
        <Column field="status" header="Status"></Column>
        <Column field="created_at" header="Crée le"></Column>
      </MeaDataTable>
      {/*<UpdateSystemSchoolModal ref={updateModalRef} school={school} />*/}
    </>
  );
});

export default SystemAccountsListComponent;
